var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchFilterActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7802",
    "data-name": "Group 7802",
    transform: "translate(-816 -72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10018",
    "data-name": "Rectangle 10018",
    width: 25,
    height: 25,
    rx: 4,
    transform: "translate(816 72)",
    fill: "#126cfc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sliders",
    transform: "translate(821.04 76.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M13.19,3.331A2.331,2.331,0,1,1,10.859,1,2.331,2.331,0,0,1,13.19,3.331Zm-2.331,1.4a1.4,1.4,0,1,0-1.4-1.4A1.4,1.4,0,0,0,10.859,4.73Zm-4.2,3.264A2.331,2.331,0,1,1,4.331,5.662,2.331,2.331,0,0,1,6.662,7.994Zm-2.331,1.4a1.4,1.4,0,1,0-1.4-1.4A1.4,1.4,0,0,0,4.331,9.392Zm8.859,3.264a2.331,2.331,0,1,1-2.331-2.331A2.331,2.331,0,0,1,13.19,12.656Zm-2.331,1.4a1.4,1.4,0,1,0-1.4-1.4A1.4,1.4,0,0,0,10.859,14.055Z",
    transform: "translate(-0.135)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M8.859,3.932H0V3H8.859Zm6.061,0H12.589V3H14.92ZM8.859,13.257H0v-.932H8.859Zm6.061,0H12.589v-.932H14.92ZM6.061,8.595H14.92V7.662H6.061ZM0,8.595H2.331V7.662H0Z",
    transform: "translate(0 -0.135)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchFilterActive);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij4KICA8ZyBpZD0iR3JvdXBfNzgwMiIgZGF0YS1uYW1lPSJHcm91cCA3ODAyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODE2IC03MikiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xMDAxOCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTAwMTgiIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgcng9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgxNiA3MikiIGZpbGw9IiMxMjZjZmMiLz4KICAgIDxnIGlkPSJzbGlkZXJzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MjEuMDQgNzYuNTA2KSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzEyMzAiIGRhdGEtbmFtZT0iUGF0aCAxMjMwIiBkPSJNMTMuMTksMy4zMzFBMi4zMzEsMi4zMzEsMCwxLDEsMTAuODU5LDEsMi4zMzEsMi4zMzEsMCwwLDEsMTMuMTksMy4zMzFabS0yLjMzMSwxLjRhMS40LDEuNCwwLDEsMC0xLjQtMS40QTEuNCwxLjQsMCwwLDAsMTAuODU5LDQuNzNabS00LjIsMy4yNjRBMi4zMzEsMi4zMzEsMCwxLDEsNC4zMzEsNS42NjIsMi4zMzEsMi4zMzEsMCwwLDEsNi42NjIsNy45OTRabS0yLjMzMSwxLjRhMS40LDEuNCwwLDEsMC0xLjQtMS40QTEuNCwxLjQsMCwwLDAsNC4zMzEsOS4zOTJabTguODU5LDMuMjY0YTIuMzMxLDIuMzMxLDAsMSwxLTIuMzMxLTIuMzMxQTIuMzMxLDIuMzMxLDAsMCwxLDEzLjE5LDEyLjY1NlptLTIuMzMxLDEuNGExLjQsMS40LDAsMSwwLTEuNC0xLjRBMS40LDEuNCwwLDAsMCwxMC44NTksMTQuMDU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMTM1KSIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzEyMzEiIGRhdGEtbmFtZT0iUGF0aCAxMjMxIiBkPSJNOC44NTksMy45MzJIMFYzSDguODU5Wm02LjA2MSwwSDEyLjU4OVYzSDE0LjkyWk04Ljg1OSwxMy4yNTdIMHYtLjkzMkg4Ljg1OVptNi4wNjEsMEgxMi41ODl2LS45MzJIMTQuOTJaTTYuMDYxLDguNTk1SDE0LjkyVjcuNjYySDYuMDYxWk0wLDguNTk1SDIuMzMxVjcuNjYySDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0wLjEzNSkiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";